<div *ngIf="step !== 2" class="page-container" [class.is-demo]="isDemo" [class.pdf-layout]="step === 2">
  <div>
    <app-breadcrumbs *ngIf="breadcrumbs && breadcrumbs.length > 0" [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

    <h1 *ngIf="!(isDemo && step === 0)">{{titles[step]}}</h1>

    <app-tabs-buttons *ngIf="step === 0" [buttons]="tabButtons" [(selectedButton)]="selectedTabButton" (selectedButtonChange)="changeView($event)"></app-tabs-buttons>

    <app-upload-step *ngIf="step === 0 && selectedTabButton.view === 'file-upload'" [form]="uploadStepForm!" [files]="uploadedFiles || []" [filesUploading]="filesUploading" (selectedFilesChange)="onFilesChanged($event)"></app-upload-step>
    <app-text-step *ngIf="step === 0 && selectedTabButton.view === 'text'" [form]="textStepForm!" [selectedFiles]="uploadedFiles" (selectedFilesChange)="onFilesChanged($event)"></app-text-step>

    <div *ngIf="step === 1">
      <app-progress-loader [duration]="22000" [messages]="selectedTabButton.view === 'fileUpload' ? fileProcessingMessages : textProcessingMessages"></app-progress-loader>
    </div>
  </div>

  <div class="footer" [class.is-demo]="isDemo">
    <div class="buttons-container">
      <app-button [hidden]="step === 0" [text]="'misc.back' | translate" (clickEvent)="prevStep()" [style]="'outlined'"></app-button>
      <app-button *ngIf="step < 2" [hidden]="step === 1" [text]="nextButtonTexts[step] | translate" (clickEvent)="nextStep()" [loading]="isLoading"></app-button>
      <app-button *ngIf="step === 2" [text]="'Alle übernehmen (' + flashcardsCount + ')'" (clickEvent)="nextStep()" [loading]="isLoading"></app-button>
    </div>
    <span *ngIf="errorMessage" class="error-message">{{errorMessage}}</span>
  </div>
</div>

<app-flashcards-check-step *ngIf="step === 2 && selectedTabButton.view === 'file-upload'" [isDemo]="isDemo" [pdfSrc]="pdfSrc" [files]="uploadedFiles" [learnset]="learnset" [(pages)]="pages" (pagesChange)="calcTotalFlashcards()" (navigateBack)="prevStep()"></app-flashcards-check-step>
<app-flashcards-preview *ngIf="step === 2 && selectedTabButton.view === 'text'" [isDemo]="isDemo" [flashcards]="flashcards" [learnset]="learnset!" (navigateBack)="prevStep()" (pagesChange)="calcTotalFlashcards()"></app-flashcards-preview>